// NATIVE 
import React, { useEffect } from 'react';


// CUSTOM 
import { Avatar } from '@mui/material';
import { useDispatch } from 'react-redux';
import { deepOrange } from '@mui/material/colors';



// INSTALLED 
import { getImageStore } from '../store/files';




export const AvatarUsuariosPermissions = ({ urlImage, typeImage }: any) => {


     // DISPATCH 
     const dispatch = useDispatch();


    // USE STATES
    const [logoUrl, setLogoUrl] = React.useState('');



    const getLogoImage = async(imageName:string) => { 
    

          const response =  await dispatch( getImageStore(imageName, typeImage) );


           if ( response instanceof Blob) {
              const imageUrl = URL.createObjectURL(response);
              setLogoUrl(imageUrl);
           }

    }


    useEffect(() => {
        getLogoImage(urlImage);
    }, [urlImage]);
    

  return (
    <>
       <Avatar
            sx={{ bgcolor: deepOrange[500], width: 140, height: 140, textAlign: 'center' }}
            sizes={'100'}
            alt="Avatar Empleado"  
            src={ logoUrl }
            variant='square'
        >
            Q
        </Avatar>
    </>
  )
}

